export default __webpack_public_path__ + "static/media/526w.7a43e9d3.svg";